import xbytes from 'xbytes'

export default class File {
  icon: string
  name: string
  size: number
  sizeFormatted: string
  type: string

  constructor (file: File) {
    this.name = file.name
    this.type = file.type
    this.size = file.size
    this.sizeFormatted = xbytes(file.size)
    this.icon = this.setIconBasedOnFileType(file.type)
  }

  private setIconBasedOnFileType (fileType: string): string {
    switch (fileType) {
      case 'application/pdf':
        return 'pdf'
      default:
        return 'default'
    }
  }
}
